import React from 'react';
import ComicPanel from '../components/ui/ComicPanel';

const comedians = [
  { id: 1, name: "The Chuckle King", genre: "Stand-up", day: "Friday", img: "https://images.unsplash.com/photo-1544717297-fa95b6ee9643?q=80&w=400&auto=format&fit=crop" },
  { id: 2, name: "Sarah Smiles", genre: "Musical Comedy", day: "Saturday", img: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=400&auto=format&fit=crop" },
  { id: 3, name: "Duo De-Struct", genre: "Sketch", day: "Sunday", img: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?q=80&w=400&auto=format&fit=crop" },
  { id: 4, name: "Improv All-Stars", genre: "Improv", day: "Friday", img: "https://images.unsplash.com/photo-1522075469751-3a3694c60e9e?q=80&w=400&auto=format&fit=crop" },
  { id: 5, name: "Late Night Laughs", genre: "Variety", day: "Saturday", img: "https://images.unsplash.com/photo-1595152772835-219674b2a8a6?q=80&w=400&auto=format&fit=crop" },
  { id: 6, name: "Open Mic Finals", genre: "Competition", day: "Thursday", img: "https://images.unsplash.com/photo-1463453091185-61582044d556?q=80&w=400&auto=format&fit=crop" },
];

const LineUp = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="bg-comic-yellow border-4 border-black p-4 mb-12 inline-block transform -rotate-1">
        <h1 className="font-comic text-6xl">THE LINE UP</h1>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {comedians.map((act) => (
          <ComicPanel key={act.id} title={act.day} className="h-full flex flex-col hover:transform hover:-translate-y-2 transition-transform duration-200">
            <div className="border-2 border-black h-64 overflow-hidden mb-4 relative group">
                <img src={act.img} alt={act.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-300" />
                <div className="absolute top-2 right-2 bg-comic-red text-white font-comic px-2 border-2 border-black rotate-3">
                    {act.genre}
                </div>
            </div>
            <h2 className="font-comic text-3xl mb-2">{act.name}</h2>
            <p className="font-body text-gray-700 mb-4 flex-grow">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Prepare for side-splitting chaos!
            </p>
            <button className="w-full font-comic bg-black text-white text-xl py-2 hover:bg-comic-blue hover:text-white transition-colors">
                BOOK NOW
            </button>
          </ComicPanel>
        ))}
      </div>
    </div>
  );
};

export default LineUp;